import { FC, useState } from 'react';
import cx from 'classnames';
import styles from './Image.module.scss';

export interface ImageProps {
  alt?: string;
  className?: string;
  fallBack: FC<{ className?: string }>;
  height?: string;
  src?: string | null;
  width?: string;
}

const Image: FC<ImageProps> = ({ alt, className, fallBack: FB, src }) => {
  const [imageLoading, setImageLoading] = useState(true);

  const displayFallBack = !src || imageLoading;

  return (
    <>
      {displayFallBack && <FB className={className} />}
      {src && <img alt={alt} className={cx(className, { [styles.loading]: imageLoading })} src={src} onLoad={() => setImageLoading(false)} />}
    </>
  );
};

export default Image;
